(ns app.front.view.group.admin.form-schemas.forms
  (:require [app.domain.form.schema :as form-schema]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.form-schemas.declarations :as declarations]
            [app.front.view.group.admin.form-schemas.util :as form-schemas-util]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]
            [schema.core :as s]))


(rf/reg-sub ::supported-schema-types
  :<- [::ff/enabled-flags]
  :<- [::gas/group-features]
  :-> form-schema/supported-schema-types)


(rf/reg-event-fx ::fetch-form-schemas
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/form-schema-entities-for-form-editor
                    :method     :get
                    :data       {:authority-group-id group-id}
                    :on-success [::entities/merge-entity-db]}}))


(rf/reg-sub ::form-schemas :-> ::form-schemas)
(rf/reg-sub ::new-form-schema :-> ::new-form-schema)


(rf/reg-sub ::new-form-schema.name-on-form
  :<- [::new-form-schema]
  :-> :name-on-form)


(rf/reg-sub ::new-form-schema.name-in-config
  :<- [::new-form-schema]
  :-> :name-in-config)


(rf/reg-sub ::new-form-schema.base-for-schema
  :<- [::new-form-schema]
  :-> :base-for-schema)


(rf/reg-sub ::new-form-schema.authority-form?
  :<- [::new-form-schema]
  #(-> % :authority-form? boolean))


(rf/reg-sub ::new-form-schema.type
  :<- [::new-form-schema]
  :<- [::schema-type-options]
  (fn [[s options] _]
    (:type s (or (p/find-first options #(= % :form.schema.type/general))
                 (first options)))))


(rf/reg-sub ::create-form-schema.processing?
  :<- [::new-form-schema]
  :-> ::create-form-schema.processing?)


(rf/reg-sub ::schema-type-options
  :<- [::gas/group-permit-types]
  :<- [::supported-schema-types]
  (fn [[permit-types supported-schema-types] _]
    (form-schema/schema-options permit-types supported-schema-types)))

(rf/reg-event-db ::edit-attrs-of-new-schema
  (fn [db [_ new-attrs]]
    (update db ::new-form-schema merge new-attrs)))


(rf/reg-event-fx ::create-form-schema.success
  (fn [{:keys [db]} [_ group-id _ resp]]
    {:db         (-> db
                     (assoc ::create-form-schema.processing? false)
                     (dissoc ::new-form-schema))
     :route/push {:route  :view/group.admin.form
                  :params {:schema-id (ffirst resp)
                           :group-id  group-id}}}))


(rf/reg-event-fx ::create-form-schema
  (fn [{:keys [db]} [_ {:keys [authority-group-id] :as data}]]
    {:db           (assoc db ::create-form-schema.processing? true)
     :comm/command {:command    :group/create-form-schema
                    :method     :post
                    :data       (p/filter-vals some? data)
                    :on-success [::create-form-schema.success authority-group-id]
                    :notify     {:success :form.schema/create-form-schema.success}}}))


(rf/reg-sub ::sorted-forms
  (fn [[_ group-id]]
    [(rf/subscribe [::entities/entities {:entity/type            :entity.type/form-schema
                                         :domain/authority-group group-id}])
     (rf/subscribe [::supported-schema-types])])
  (fn [[forms supported-schema-types] _]
    (let [supported-schema-types (set supported-schema-types)]
      (->> forms
           (filter du/is-active?)
           (filter #(->> (form-schema/resolve-schema-type %)
                         (contains? supported-schema-types)))
           (sort-by :form.schema/name)))))

(defn inherited-forms []
  (when-let [superdomain (<sub [::gas/superdomain])]
    (->> (<sub [::sorted-forms (:db/id superdomain)])
         (remove form-schema/schema-has-no-fields?)
         (map #(form-schemas-util/rename-inherited-form-schema % superdomain)))))

(defn view [match]
  (r/with-let [*modal-open? (r/atom false)
               on-close     #(reset! *modal-open? false)]
    (let [{:keys [group-id]}         (-> match :parameters :path)
          tr                         (<sub [::gas/group-tr])
          inherited-forms            (when (ff/enabled? :feature-flag.id/superdomain-can-manage-forms)
                                       (inherited-forms))
          form-schemas               (concat (<sub [::sorted-forms group-id]) inherited-forms)
          new-schema-name-on-form    (<sub [::new-form-schema.name-on-form])
          new-schema-name-in-config  (<sub [::new-form-schema.name-in-config])
          new-schema-authority-form? (<sub [::new-form-schema.authority-form?])
          base-for-new-schema        (<sub [::new-form-schema.base-for-schema])
          schema-type                (<sub [::new-form-schema.type])
          schema-type-options        (<sub [::schema-type-options])]
      (if (<sub [::create-form-schema.processing?])
        (cc/loading-spinner {:with-overlay true})
        [acommon/admin-page
         (util/mmap {:title (tr [:group.config/form-schemas])} match)
         [:section
          [:div
           [:h2 (tr [:form.schema/published-forms])]
           [:div.mt-2.mb-4
            (if (seq schema-type-options)
              (cc/button
                {:id               "add-form-button"
                 :kind             :tertiary
                 :icon-description ""
                 :on-click         #(reset! *modal-open? true)
                 :icon             i/plus}
                (tr [:form.schema/add-form]))
              [ui/help (tr [:form.schema/no-available-schemas])])]
           [ui-modal/composed-input-modal
            {:open     @*modal-open?
             :on-close on-close}
            (cc/modal-header
              {:close-modal on-close
               :title       (tr [:form.schema/add-new-form])})
            (cc/modal-body
              {}
              [:<>
               [ui/text-input
                {:id         "new-form-schema-name"
                 :value      new-schema-name-on-form
                 :required   true
                 :label-text (tr [:form.schema/new-form-name])
                 :on-change  #(rf/dispatch-sync [::edit-attrs-of-new-schema {:name-on-form (futil/tval %)}])}]
               [:div.mt-4
                [ui/text-input
                 {:id         "new-form-configuration-name"
                  :value      new-schema-name-in-config
                  :required   true
                  :label-text (tr [:form.schema/new-form-name-in-configuration])
                  :on-change  #(rf/dispatch-sync [::edit-attrs-of-new-schema {:name-in-config (futil/tval %)}])}]]
               [:div.mt-4
                (cc/checkbox
                  {:id         "authority-only-form-checkbox"
                   :label-text (tr [:form.schema/authority-form])
                   :checked    new-schema-authority-form?
                   :on-change  #(rf/dispatch-sync [::edit-attrs-of-new-schema {:authority-form? %}])})]
               [:div.mt-4
                [ui-select/select
                 {:id           "schema-type"
                  :label-text   (tr [:form.schema/form-type])
                  :value        schema-type
                  :values       schema-type-options
                  :val->str     #(tr [%])
                  :required     true
                  :allow-empty? false
                  :on-change    #(rf/dispatch [::edit-attrs-of-new-schema {:type %}])}]]])
            (cc/modal-footer
              {}
              (cc/button
                {:kind     :secondary
                 :on-click on-close}
                (tr [:cancel]))
              (cc/button
                {:kind     :primary
                 :disabled (or (util/nil-or-blank? new-schema-name-on-form)
                               (util/nil-or-blank? new-schema-name-in-config))
                 :on-click (fn [_]
                             (>evt [::create-form-schema
                                    {:base-schema        (:form.schema/data-schema base-for-new-schema)
                                     :authority-group-id group-id
                                     :name-on-form       new-schema-name-on-form
                                     :name-in-config     new-schema-name-in-config
                                     :authority-form?    new-schema-authority-form?
                                     :schema-type        schema-type}])
                             (on-close))}
                (tr [:form.schema/create-form])))]
           (when (seq form-schemas)
             [ui-table/modern-responsive-table
              {:items              form-schemas
               :tr                 tr
               :row-class-override "lg:items-center hover:bg-ui-blue-10"
               :cols               [[:form.schema/name
                                     #(cc/link {:href (href/href :view/group.admin.form
                                                                 {:schema-id (:db/id %)
                                                                  :group-id  group-id})}
                                               (:form.schema/name %))]
                                    [:form.schema/form-type
                                     #(tr [(form-schema/resolve-schema-type %)])]
                                    [:form.schema/authority-form
                                     (fn [schema]
                                       (if (form-schemas-util/is-authority-form-schema? schema)
                                         (tr [:yes])
                                         (tr [:no])))]
                                    [:form.schema/version
                                     :form.schema/version]
                                    [:form.schema/updated-by
                                     (fn [{:keys [latest-change]}]
                                       (if latest-change
                                         (tr [:last-change-by] [((<sub [::date-util/date-time-fn]) (:ts latest-change))
                                                                (:user latest-change)])
                                         "-"))
                                     {:max-width "500px"}]]}])]]
         ;;hiding declarations until `WIN-5374: Shared Services Group - Declarations` gets implemented
         (when-not (<sub [::gas/superdomain-group?])
           [declarations/declaration-section])]))))

(def route
  "The form editor accessible by authority admins from the municipality view menu"
  {:name        :view/group.admin.forms
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::gas/fetch-party-roles group-id])
                                  (>evt [::fetch-form-schemas group-id])))}]})
